import { useState, useSyncExternalStore } from 'react'
import { applyPwaUpdate, getPwaUpdateState, subscribePwaUpdate } from '../pwa'

export default function PwaUpdateNotice() {
  const {available}=useSyncExternalStore(subscribePwaUpdate,getPwaUpdateState)
  const [later,setLater]=useState(false),[busy,setBusy]=useState(false),[error,setError]=useState('')
  if(!available || later)return null
  return <aside className="pwa-update-notice" aria-label="Atualização disponível">
    <div><strong>Nova versão disponível</strong><p>Salve suas alterações antes de atualizar. O aplicativo será reaberto.</p>{error&&<p role="alert">{error}</p>}</div>
    <div className="pwa-update-actions"><button type="button" className="button ghost compact" disabled={busy} onClick={()=>setLater(true)}>Depois</button><button type="button" className="button primary compact" disabled={busy} onClick={async()=>{setBusy(true);setError('');try{await applyPwaUpdate()}catch(e){setError(e instanceof Error?e.message:'Não foi possível atualizar.');setBusy(false)}}}>{busy?'Atualizando…':'Atualizar agora'}</button></div>
  </aside>
}
